<h-call-to-action
    [name]="'vto-call-to-action'"
    [id]="'vto-call-to-action'"
    [appearance]="'primary'"
    [size]="'medium'"
    (pressed)="click()"
    class="vto-button">
    <h-svg-icon class="vto-cta-icon" [name]="'vto'" svgLeft></h-svg-icon>
    <span class="label-large-uppercase vto-title">{{ text }}</span>
</h-call-to-action>
